import React, { Component } from 'react';
import block from 'bem-cn-lite';
import Task from '../Task';
import CustomScroll from 'react-custom-scroll';
import placeholder from '../placeholder';
import BlinkingMarker from '../../Components/BlinkingMarker';
import { I18n } from 'react-i18next';

block.setup({
    mod: '--'
});
const b = block('Column');
const p = block('Placeholder');
const empty = block('EmptyPlaceholder');

class Column extends Component {
    dragEnter(e) {}
    render() {
        const { name, color, id, tasks, isOver, marked, currentDrag } = this.props;
        return (
            <I18n>
            {
                (t) => (
                    <div className={b()} onDragEnter={this.dragEnter}>
                        <div
                            style={{ borderColor: color }}
                            className={b('header', { color: 'red' })}
                        >
                            {name}
                        </div>
                        <div
                            className={b('tasks', {
                                empty: tasks.length === 0 && id === 3 && !isOver
                            })}
                        >

                            { tasks.length === 0 && id === 3 && !isOver ?
                                <div className={empty()}>
                                    <div className={empty('icon-wrp')}>
                                        <img src="https://cdn.wrike.com/image/__cdnu/icon_grey_vector_fun_boards_empty.svg" alt="" className={empty('icon')} />
                                    </div>
                                    <div className={empty('title')}>{t('boards:empty.title')}</div>
                                    <div className={empty('desc')}>{t('boards:empty.description')}</div>
                                </div>
                            
                            :
                                <CustomScroll 
                                    allowOuterScroll={ true }
                                    heightRelativeToParent="430px">
                                    <div className={b('tasks-inner')}>
                                        {(marked && currentDrag.id !== 0 && currentDrag.marked) && <BlinkingMarker top={64} left={94}/>}
                                        {tasks.map(task =>
                                            <Task
                                                {...task}
                                                onDrag={this.props.onDrag}
                                                onChange={this.props.onTaskChange}
                                                key={task.id}
                                                animate={this.props.animate}
                                            />
                                        )}

                                        {isOver &&
                                            <div 
                                                className={p({ position: 'after' })} 
                                                style={{height: placeholder.height}}
                                            />
                                        }
                                    </div>
                                </CustomScroll>
                            }
                        </div>
                    </div>
                )
            }
            </I18n>
            
        );
    }
}

export default Column;
